import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReadingSettingsDataService } from './reading-settings-data.service';

@Injectable({
  providedIn: 'root'
})
export class DevisionsService {

  constructor(private httpClient: HttpClient, private readingSettingsData: ReadingSettingsDataService) { }

  getDevisions(gradeId: number) {
    return this.httpClient.get(this.readingSettingsData.getSchoolDomain() + "/website/devisions/getDevisions?gradeId=" + gradeId)
  }
}
